<script>
    export let checked = false;
    export let color = "#2196F3";
  </script>
  
  <style>
    .switch {
      position: relative;
      display: inline-block;
      width: 34px;
      height: 20px;
      -webkit-tap-highlight-color: transparent; 
      -webkit-touch-callout: none; 
      user-select: none;
    }
  
    .switch input {
      opacity: 0;
      width: 0;
      height: 0;
    }
  
    .slider {
      position: absolute;
      cursor: pointer;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background-color: rgb(153, 152, 152);
      -webkit-transition: 0.4s;
      transition: 0.4s;
      border-radius: 20px;
    }
  
    .slider:before {
      position: absolute;
      content: "";
      height: 16px;
      width: 16px;
      left: 2px;
      bottom: 2px;
      background-color: white;
      -webkit-transition: 0.4s;
      transition: 0.4s;
      border-radius: 50%;
    }
  
    input:checked + .slider {
      background-color: rgba(65, 255, 249, 0.718);
    }
  
    input:checked + .slider {
      box-shadow: 0 0 1px #2196f3;
    }
  
    input:checked + .slider:before {
      -webkit-transform: translateX(14px);
      -ms-transform: translateX(14px);
      transform: translateX(14px);
    }
  </style>
  
  <label class="switch" style='align-items: flex-end;'>
    <input type="checkbox" bind:checked />
    <span class="slider" />
  </label>